import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import MenuIcon from "../images/menu-three-dots.svg";
import MenuSelectedIcon from "../images/menu-selected.svg";
import ImageIcon from "../images/file-image.svg";
import PDFIcon from "../images/pdf-img.png";
// import "../scss/Shared/commonFields.scss";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
import { fileFormats } from "../utils/GeneralUtils";
import { update } from "lodash";

const FileUpload = ({
  maxFiles,
  acceptedFormats,
  displayAccepedFormats,
  noClick,
  noDrag,
  maxSize,
  input: { onChange, value },
  meta: { error, touched },
  label,
  disabled,
  isRequired,
  className,
  showFilesList,
  displayOnlyFiles,
  handleChange,
  optional,
  onHandleClick,
  onRemoveClick,
  browse,
  reference
}: any) => {
  const [files, setFiles] = useState<any>(value || []);
  const [fileDropdown, setFileDropdown] = useState("");
  const [disabledDropzone, setDisableFields] = useState(false);
  const [duplicatePresent, setDuplicatePresent] = useState(false);
  const [dropDocumentId, setDropDocumentId] = useState<any>(null);
  const [documentId, setDocumentId] = useState("");

  const toggleFileDropdown = (event: any, valueText: string) => {
    event.stopPropagation();
    if (fileDropdown === valueText) {
      setFileDropdown("");
    } else {
      setFileDropdown(valueText);
    }
  };


  //Handling Duplication issue

  useEffect(() => {
    if (reference) {
      reference.current = removeFiles
    }
  }, [])



  const removeFiles = () => {
    setFiles([]);
  }


  const onDrop = useCallback((acceptedFiles: any, index: any) => {
    const updateUniqueDocumentId = acceptedFiles?.map((file: any, index: any) => {
      const uniqueId = uuidv4();
      file.localDocumentUniqueId = uniqueId;
      return file;
    });
    const newFiles =
      files?.length > 0 ? [...files, ...updateUniqueDocumentId] : updateUniqueDocumentId;
    setFiles(newFiles);
    onChange(newFiles);
    handleChange && handleChange(newFiles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },
    [files]
  );

  // const onDrop = useCallback(
  //   (acceptedFiles: any) => {
  //     setFiles((prevFiles: any) => {
  //       const newFiles =
  //         prevFiles?.length > 0
  //           ? [...prevFiles, ...acceptedFiles]
  //           : acceptedFiles;
  //       const isPresentTwice =
  //         newFiles.filter((item: any) => item.name === acceptedFiles[0].name)
  //           .length >= 2;
  //       if (!isPresentTwice) {
  //         onChange(newFiles);
  //         handleChange && handleChange(newFiles);
  //         return newFiles;
  //       } else {
  //         toast.error("Same file already uploaded");
  //         const previousFiles = [...prevFiles];
  //         return previousFiles;
  //       }
  //     });
  //   },
  //   [onChange, handleChange]
  // );

  // const getFormats = () => {
  //   const formats: any = {};
  //   if (acceptedFormats && acceptedFormats?.length > 0) {
  //     acceptedFormats?.forEach((each: string) => {
  //       formats[each] = [];
  //     });
  //     return formats;
  //   } else return { "application/pdf": [] };
  // };

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    maxFiles: maxFiles,
    maxSize: maxSize,
    noClick: noClick,
    noDrag: noDrag,
    disabled: disabled || disabledDropzone,
    accept: acceptedFormats,
  });

  useEffect(() => {
    if (acceptedFiles && acceptedFiles?.length === maxFiles) {
      setDisableFields(true);
    } else {
      setDisableFields(false);
    }
  }, [acceptedFiles, maxFiles]);

  useEffect(() => {
    setFiles(value);
  }, [value])

  useEffect(() => {
    if (fileRejections && fileRejections?.length > 0) {
      toast.error(fileRejections[0].errors?.[0]?.message);
    }
  }, [fileRejections]);

  const removeFile = (event: any, file: any) => {
    if (file.localDocumentUniqueId) {
      event.stopPropagation();
      const remainingFiles = files.filter((each: any) => each.localDocumentUniqueId !== file.localDocumentUniqueId);
      setFiles(remainingFiles);
      onChange(remainingFiles);
      handleChange && handleChange(remainingFiles);
      setDisableFields(false);
      return;
    } else {
      event.stopPropagation();
      const remainingFiles = files.filter((each: any) => each.documentUniqueId !== file.documentUniqueId);
      setFiles(remainingFiles);
      onChange(remainingFiles);
      handleChange && handleChange(remainingFiles);
      acceptedFiles.splice(file, 1);
      setDisableFields(false);
      onRemoveClick(file);
    }

  };

  const filePreview = (file: any) => {
    onHandleClick(file);
  }

  const acceptedFileItems = () => {

    return (files?.map((file: any, index: any) => (

      <div key={index} className="render-preview" onClick={() => filePreview(file)}>
        <p className="details">
          <img className="pdfIcon" src={PDFIcon} alt="PDFIcon" />
          <span className="fileName">{file.path}</span>
        </p>
        {<Dropdown
          className="file-dropdown"
          isOpen={fileDropdown === file?.documentUniqueId || fileDropdown === file.localDocumentUniqueId}
          toggle={(event: any) => toggleFileDropdown(event, file?.documentUniqueId || file.localDocumentUniqueId)}
        >
          <DropdownToggle>
            <img
              className="menuIcon"
              src={fileDropdown == file?.path ? MenuSelectedIcon : MenuIcon}
              alt="MenuIcon"
            />
          </DropdownToggle>
          {!disabled && <DropdownMenu>
            <DropdownItem onClick={(e: any) => removeFile(e, file)}>Delete</DropdownItem>
          </DropdownMenu>}
        </Dropdown>}
      </div>
    )))
  }


  const getFieldBottomClassName = () => {
    if (touched && error) {
      return "field-bottom error danger";
    } else {
      return "field-bottom";
    }
  };

  const getFieldBottomValue = () => {
    if (touched && error) {
      return touched && error ? error : "";
    } else {
      return "";
    }
  };

  return (
    <div className="fileUploadContainer">
      <label>
        {label}
        {isRequired && <span className="input-required">*</span>}
        {optional && <span className="optional">(optional)</span>}
      </label>
      {displayAccepedFormats && <span>Please upload {acceptedFormats} </span>}
      <div className="inputContainer">
        {displayOnlyFiles ? (
          <></>
        ) : (
          <div
            className={`
            fileUpload 
            ${disabled ? "disabled" : ""} 
            ${isDragAccept ? "isDragAccept" : ""}
            ${isDragReject ? "isDragReject" : ""}
          `}
          >
            <div
              {...getRootProps({ className: `fileInner ${className ?? ""}` })}
            >
              <input className="fileInput" {...getInputProps()} />
              {/* <img src={ImageIcon} alt="ImageIcon" /> */}
              <>
                <p className="browse">
                  {browse ? browse : <>Drag files here or <span className="link">browse</span></>}
                </p>
                {/* <p className="supports">supports only PDF.</p> */}
              </>
            </div>
          </div>
        )}
        {showFilesList && files && files?.length > 0 ? (
          <div className="uploadedFiles">
            <div className="files">{acceptedFileItems()}</div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <h6 className={getFieldBottomClassName()}>{getFieldBottomValue()}</h6>
    </div>
  );
};

export default FileUpload;
